<template>
  <div class="pb-section-container margin-top-16">
    <div
      :class="[
        'pbs-header-container',
        active ? 'active' : null,
      ]"
    >
      <button
        v-if="finishedSection.includes('planType') && !active"
        type="button"
        class="pbs-done-button"
        @click="changeActiveStepIdx(index)"
      >
        Edit
      </button>
      <button v-else-if="!active && !finishedSection.includes('planType')" type="button" class="pbs-button" @click="changeActiveStepIdx(index)">
        Start
      </button>
      <button v-else type="button" class="pbs-close-button" @click="changeActiveStepIdx(-1)">
        <img src="@shared/assets/img/setting/chevron-up.svg" alt="Close">
      </button>
      <div class="pbs-header">
        Hardware-enabled plan
      </div>
      <div v-if="apponlyAllowed" class="pbs-header-right-container">
        <SACToggleSwitch
          :checked="planType === 'Hardware'"
          :change="handleContinue"
          :disabled="editing"
        />
      </div>
    </div>
    <div
      :class="[
        'pbs-body-container pricing-section',
        active ? 'active' : null,
      ]"
    >
      <div class="pbs-title-container margin-top-16">
        <div class="pbs-title">
          Detect - SmartAC.com Hardware
        </div>
      </div>
      <div class="pbs-sub-header gray">
        <div class="plan-details">
          <p>
            Smart sensors &amp; installation are always included in
            hardware-enabled plans. Members on these plans qualify for:
          </p>
          <ul>
            <li>24/7 monitoring</li>
            <li>Monthly system health reports</li>
            <li>Virtual/flex maintenance visits</li>
          </ul>
          <p>
            Both types of plans feature discounted filter replacements,
            in-app scheduling, and exclusive promotions and vouchers for your members.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatterMixin from '@shared/mixins/formatterMixin';
import SACToggleSwitch from '@shared/components/sac/SACToggleSwitch.vue';

export default {
  name: 'PlanType',
  components: {
    SACToggleSwitch,
  },
  mixins: [formatterMixin],
  props: {
    index: Number,
    active: Boolean,
    changeActiveStepIdx: Function,
    plan: Object,
    updatePlan: Function,
    finishedSection: Array,
    toggleInfoModal: Function,
    apponlyAllowed: Boolean,
    editing: Boolean,
  },
  data() {
    return {
      planType: this.plan.planType ?? 'Hardware',
    };
  },
  watch: {
    plan(updatedPlan) {
      this.planType = updatedPlan?.planType ?? 'Hardware';
    },
  },
  methods: {
    handleContinue(event) {
      let planType = 'AppOnly';
      if (this.apponlyAllowed && !event.target.checked) {
        planType = 'Hardware';
      }
      this.changeActiveStepIdx(this.index + 1);
      const newPlan = {
        ...this.plan,
        planType,
      };
      this.updatePlan(newPlan, 'planType');
    },
  },
};
</script>
<style lang="scss">
.plan-details {
  font-size: 14px;
  color: #6b6b7b;
  line-height: 1.5;
  max-width: 600px;

  ul {
    list-style-type: disc;
    margin: 10px 0 10px 20px;
    padding: 0;
  }

  li {
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 15px;
  }
}
</style>
